// keep in sync with code $color-secondary-10;
export const themeColorDark = '#00122a';
// keep in sync with code $color-secondary-06;
export const themeColorLight = '#001e46';
